var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.026 13.5234H2.41747C2.18691 13.5234 2 13.3365 2 13.106V6.28727C2 6.05671 2.18691 5.8698 2.41747 5.8698H4.34314C4.83195 5.8698 5.28491 5.61333 5.5364 5.19418L7.42225 2.05106C7.82922 1.37286 8.78766 1.30838 9.28174 1.92599C9.51462 2.2171 9.5897 2.60403 9.48254 2.96111L8.77117 5.33237C8.69081 5.60022 8.89141 5.8698 9.17104 5.8698H12.3543C13.2719 5.8698 13.9383 6.74231 13.6968 7.62749L12.3685 12.498C12.2034 13.1035 11.6535 13.5234 11.026 13.5234Z",
    stroke: "#A0A0A0",
    strokeWidth: 1.04368,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.43555 13.5238V5.87012",
    stroke: "#A0A0A0",
    strokeWidth: 1.04368,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.e7c6a2e6660b0daa1e9fcef198d2f853.svg";
export { ForwardRef as ReactComponent };